'use strict';

import Constants from '../constants';
import { resultsMaker as ResultsMaker } from '../../../../helpers/reducer';

export default ResultsMaker(Constants.GET_TOS_AGREED_RESULTS,  Constants.GET_TOS_AGREED_RESULTS_RESPONSE );
